// extracted by mini-css-extract-plugin
module.exports = {"root":"InputsConfig_root__2Oiyv","title":"InputsConfig_title__3R1vK","inputDropdown":"InputsConfig_inputDropdown__1gGQm","inputSelector":"InputsConfig_inputSelector__Bu-pv"};